// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-o_fW","advertDetailContactItem__link":"c-o_fX","advertDetailContactItem__stub":"c-o_fY"};